import * as Sentry from "@sentry/nextjs";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import React from "react";

import { RouteName } from "@/consts";
import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { CircleIconButton } from "@/features/common/components/button/CircleIconButton";
import { MessageIcon } from "@/features/common/components/icons/MessaegIcon";
import { getIsOwner } from "@/features/common/helper/getIsOwner";
import { useSnackbar } from "@/features/common/hooks/snackbar/useSnackbar";
import { useHandleGraphqlError } from "@/features/common/hooks/useHandleGraphqlError";
import { useCommonIconStyles } from "@/features/common/styles";
import { useUserContext } from "@/features/user/contexts/useUserContext";

interface ActivateChatButtonProps {
  userId: string;
  accountName: string;
  isOnOverlay?: boolean;
}

export const ActivateChatButton: React.FC<ActivateChatButtonProps> = (
  props,
) => {
  const { userId, accountName, isOnOverlay } = props; //userId is the id of receiver
  const { user, ssrUserId, ready } = useUserContext();
  const router = useRouter();

  const onClickButton = async () => {
    firebase
      .analytics()
      .logEvent(AnalyticsEventEnum.PublicProfileClickMessage, {
        userId,
        accountName,
      });

    router.push(`${RouteName.Message}?receiver=${accountName}`);
  };

  if (getIsOwner({ userId: user?._id, writerId: userId, ssrUserId, ready }))
    return null;

  return (
    <CircleIconButton
      aria-label="Send Message"
      isOnOverlay={isOnOverlay}
      loading={false}
      onClick={onClickButton}
      disabled={false}
      active={false}
    >
      <MessageIcon className="w-4 h-4" />
    </CircleIconButton>
  );
};
